import React, { useContext, useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Text } from 'app/components/ui/Text'

import { routes } from 'app/routes'
import { AuthenticationContext } from 'app/Contexts/AuthenticationProvider'
import { useMutate } from 'restful-react'
import {
  ForgotPasswordInput,
  ApiError,
  ForgotPasswordResult,
} from 'EstraSuppliers'
import { endpoints } from 'app/api/endpoints'
import { HeaderContext } from 'app/Contexts/HeaderProvider'
import styled from 'styled-components'
import { Container } from 'app/components/ui/Container'
import { FormForgotPassword } from './FormForgotPassword'
import { themeEstra } from 'app/styles/themeEstra'

export const ForgotPassword: React.FC = () => {
  const authCtx = useContext(AuthenticationContext)
  const headerCtx = useContext(HeaderContext)

  const { push } = useHistory()

  const goToDashboard = () => {
    push(routes.dashboard.makeUrl())
  }

  const headerTitle = 'Area fornitori Marketing'
  const headerSubTitle = 'Azzera la tua Password'
  const ForgotPasswordText =
    "Inserisci l'indirizzo con cui ti sei registrato e riceverai una mail con le istruzioni per cambiare la password e accedere al sistema.\n\n"

  useEffect(() => {
    if (headerCtx) {
      headerCtx.updateTitles(headerTitle, headerSubTitle)
      headerCtx.updateSubtitleVariant('login_signup')
    }
  }, [])

  if (authCtx && authCtx.actor && authCtx.actor.id) {
    // user is logged already
    goToDashboard()
  }

  const [showConfirmation, setShowConfirmation] = useState(false)

  // FORGOT PASSWORD MUTATION
  const {
    mutate: sendForgotPasswordMutation,
    loading: isSubmittingMutation,
    error: apiError,
  } = useMutate<ForgotPasswordResult, ApiError, {}, ForgotPasswordInput>({
    verb: 'POST',
    path: endpoints.forgotPassword,
  })

  return (
    <ForgotPasswordWrapper>
      <Container>
        <Grid>
          <ForgotPasswordTextColumn>
            <div>
              <Text variant='s20' color={themeEstra.color.primari.grigioEstra}>
                {ForgotPasswordText}
                <Link to={routes.login.makeUrl()}>Torna indietro</Link>{' '}
              </Text>
            </div>
          </ForgotPasswordTextColumn>
          <ForgotPasswordFormColumn>
            <FormForgotPassword
              onForgotPasswordRequest={(email, setSubmitting) => {
                console.log('email :', email)
                sendForgotPasswordMutation({
                  email,
                })
                  .then(res => {
                    if (res.status === 'ok') {
                      setShowConfirmation(true)
                    }
                  })
                  .catch(() => {
                    setSubmitting(false)
                  })
              }}
              isLoading={isSubmittingMutation}
              error={apiError}
              showConfirmation={showConfirmation}
            />
          </ForgotPasswordFormColumn>
        </Grid>
      </Container>
    </ForgotPasswordWrapper>
  )
}

const ForgotPasswordWrapper = styled.div``

const Grid = styled.div`
  margin-bottom: 1rem;
  padding-top: 3rem;

  @media (min-width: ${({ theme }) => theme.bp.desktop}) {
    display: grid;
    grid-template-columns: 3fr 2fr;
    gap: 4rem;

    max-width: 1000px;

    margin-left: auto;
    margin-right: auto;
  }
`

const ForgotPasswordTextColumn = styled(Text)`
  max-width: 450px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 3rem;

  display: flex;
  align-items: center;
`

const ForgotPasswordFormColumn = styled.div`
  @media (max-width: ${({ theme }) => theme.bp.desktop}) {
    max-width: 340px;
    margin-left: auto;
    margin-right: auto;
  }
`
